<template>
  <div class="order-input time-to">
    <TimeToSelect
      :availableTimes="availableTimes"
      :timeTo="timeTo"
      :invalid="getValidationError('timeTo')"
      ref="timeTo"
      @update:timeTo="timeTo = $event"
    />
    <ValidationView :error-messages="getErrorMessages('timeTo')" />
  </div>
</template>

<script>
import timeToMixins from '@apps/order-form/src/mixins/timeTo'
import TimeToSelect from '@features/TimeTo.vue'

export default {
  name: 'TimeTo',
  components: { TimeToSelect },
  mixins: [timeToMixins],
}
</script>
